import React from 'react';
import { Badge, Button, Glyphicon, Col, Row } from 'react-bootstrap';
import moment from 'moment';
import Truncate from '../Truncate';
import translations from '../../translations';

/**
 * @description Display an individual flow library item
 *
 * This is what we want to render,
 *
 *        +--------------------------------------------------------------------------------+
 *        | {name}                              Type      Published                        |
 *        |                                     {type}    {published}                      |
 *        | {description}...                                                               |
 *        |                                                                                |
 *        | [ View ] [ Install ]                                                           |
 *        +--------------------------------------------------------------------------------+
 *
 * @param item the item to display
 * @param onView callback for View button click
 * @param onInstall callback for Install button click
 * @param dateFormat moment date format string
 * @param maxLength truncate description and replace with ... if too long
 */
const FlowLibraryListItem = ({ item, onView, onInstall, dateFormat, maxLength = 350 }) => (

    <React.Fragment>
        <Row className="details-row">
            <Col className="name" md={6}>
                <h5>
                    {item.name}
                </h5>
            </Col>
            <Col className="info" md={6}>
                <Row>
                    <Col md={6} sm={4}>
                        <span className="published-header">{translations.FL_heading_published}</span>
                        <br />
                        <span className="published">
                            {moment(item.publishedDate).format(dateFormat)}
                            {moment(item.publishedDate).isAfter(moment().subtract(1, 'month')) ? <Badge>{translations.FL_badge_new}</Badge> : ''}
                        </span>
                    </Col>
                </Row>
            </Col>
        </Row>
        <Row className="description-row">
            <Col className="description" md={5}>
                <Truncate text={item.description} maxLength={maxLength} />
            </Col>
        </Row>
        <Row className="button-row">
            <Col data-flow_id={item.flow_id} md={12}>
                <Button onClick={onView} className="view">{translations.FL_button_view}</Button>
                <Button onClick={onInstall} className="install" bsStyle="primary">
                    <Glyphicon glyph="save" />
                    <span>{translations.FL_button_install}</span>
                </Button>
            </Col>
        </Row>
        <hr />
    </React.Fragment>
);

export default FlowLibraryListItem;
